document.addEventListener("DOMContentLoaded", function() {
  //if (window.innerWidth <= 767 && window.shopifyCollection) {
    let currentPage = 1;
    let loading = false;
    let maxPages = window.shopifyCollection.maxPages;
    let productGrid = document.querySelector("#product-grid");


    /*
    *
    */
   let pagination = document.querySelector(".pagination");

  window.addEventListener("scroll", function() {
    if (!pagination || loading) return;

    let rect = pagination.getBoundingClientRect();

    // When pagination is within viewport (or near)
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      console.log("Pagination in view → load next page");
      loadNextPage();
    }
  });
  
function loadNextPage() {
  if (currentPage < maxPages) {
    loading = true;
    currentPage++;

    fetch(`${window.shopifyCollection.url}?page=${currentPage}`)
      .then(r => r.text())
      .then(data => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, "text/html");
        let newProducts = doc.querySelectorAll("#product-grid .grid__item");
        newProducts.forEach(item => productGrid.appendChild(item));
        loading = false;
      });
  }
}
 //}
});

// scroll for search results

document.addEventListener("DOMContentLoaded", function () {

    let loading = false;

    function loadNextPage() {

        if (loading) return;

        const nextLink = document.querySelector(
            '.pagination__item-arrow'
        );

        if (!nextLink) return;

        loading = true;

        fetch(nextLink.href)
            .then(res => res.text())
            .then(html => {

                const doc = new DOMParser()
                    .parseFromString(html, 'text/html');

                const newProducts =
                    doc.querySelectorAll(
                        '#product-grid .grid__item'
                    );

                const productGrid =
                    document.querySelector(
                        '#product-grid .product-grid'
                    );

                newProducts.forEach(product => {
                    productGrid.appendChild(product);
                });

                const currentPagination =
                    document.querySelector('.pagination-wrapper');

                const newPagination =
                    doc.querySelector('.pagination-wrapper');

                if (newPagination) {
                    currentPagination.innerHTML =
                        newPagination.innerHTML;
                }

                loading = false;
            });
    }

    window.addEventListener('scroll', () => {

        const pagination =
            document.querySelector('.pagination');

        if (!pagination || loading) return;

        const rect =
            pagination.getBoundingClientRect();

        if (
            rect.top <= window.innerHeight &&
            rect.bottom >= 0
        ) {
            loadNextPage();
        }
    });

});